import { userService } from '../../services'
import * as jwtDecode from 'jwt-decode'

const defaultState = {
  username: null,
  isAuthenticated: null,
  jwtToken: null,
  sessionTimedOut: false,
  isAdmin: null
}

const getters = {
  isAuthenticated: state => {
    return state.isAuthenticated
  },
  isAdmin: state => {
    return state.isAdmin
  },
  jwtToken: state => {
    return state.jwtToken
  },
  sessionTimedOut: state => {
    return state.sessionTimedOut
  }
}

const actions = {
  async registerUser({ commit }, user) {
    const response = await userService.register(user)
    // map email to username for login
    user.username = user.email
    // login user after register
    commit('userLogin', { user, response })
  },
  async loginUser({ commit }, user) {
    const response = await userService.login(user)
    commit('userLogin', { user, response })
  },
  logoutUser({ commit }) {
    userService.logout()
    commit('reset')
    commit('userLogout')
  },
  sessionTimeOut({ commit }) {
    commit('sessionTimeOut')
  }
}

const mutations = {
  userLogin(state, userData) {
    const decodedJwt = jwtDecode(userData.response)
    const isAdmin = decodedJwt.sub === 'Admin'
    if (userData.response) {
      state.isAdmin = isAdmin
      state.isAuthenticated = true
      state.username = userData.user.username
      state.jwtToken = userData.response
    }
  },
  userLogout() {
    localStorage.removeItem('vuex')
  },
  sessionTimeOut(state) {
    state.sessionTimedOut = true
  },
  reset(state) {
    // acquire initial state
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations
}
